const STEPS = [
  {
    num: "①",
    icon: "ri-edit-2-line",
    color: "bg-primary-500",
    title: "整理瓜料",
    desc: "按上面的格式要求，把你的瓜料写成文字。真实、客观、信息完整是基本要求。",
  },
  {
    num: "②",
    icon: "ri-pages-line",
    color: "bg-secondary-500",
    title: "提交投稿",
    desc: "填写投稿表单，附上必要的图片佐证，确认信息无隐私泄露后提交。",
  },
  {
    num: "③",
    icon: "ri-search-eye-line",
    color: "bg-accent-500",
    title: "进入审核",
    desc: "编辑会在 1–3 个工作日内按标准初审。通过、打回或有修改建议都会及时通知。",
  },
  {
    num: "④",
    icon: "ri-megaphone-line",
    color: "bg-primary-500",
    title: "发布推送",
    desc: "过审的优质瓜料会进入展示并有机会推送头条，作者署名保留，稿酬按规则结算。",
  },
];

export default function Process() {
  return (
    <section id="process" className="scroll-mt-20 bg-accent-50/40 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-medium text-accent-800">
              <i className="ri-git-branch-line"></i> 投稿流程
            </span>
            <h2 className="mt-4 font-display text-3xl text-foreground-900 md:text-4xl">
              从想法到上头条，只要四步
            </h2>
            <p className="mt-3 text-foreground-700">
              投稿流程清晰透明，每一步都有明确预期，你随时知道自己的瓜在哪。
            </p>
          </div>
          <div className="flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 px-5 py-3">
            <div className="flex flex-col">
              <span className="text-sm text-foreground-600">平均审核周期</span>
              <span className="text-xl font-bold text-accent-600">1–3 个工作日</span>
            </div>
            <div className="h-10 w-px bg-background-200"></div>
            <div className="flex flex-col">
              <span className="text-sm text-foreground-600">首发通过率参考</span>
              <span className="text-xl font-bold text-primary-500">约 68%</span>
            </div>
          </div>
        </div>

        <div className="relative mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          <div className="absolute left-0 right-0 top-9 hidden h-0.5 bg-gradient-to-r from-primary-200 via-secondary-200 to-accent-200 lg:block"></div>
          {STEPS.map((step) => (
            <div
              key={step.title}
              className="relative rounded-2xl border border-background-200 bg-background-50 p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative z-10 flex items-center justify-between">
                <span className={`flex h-14 w-14 items-center justify-center rounded-full text-xl text-background-50 ${step.color}`}>
                  <i className={step.icon}></i>
                </span>
                <span className="font-display text-4xl text-background-200">{step.num}</span>
              </div>
              <h3 className="mt-4 text-lg font-bold text-foreground-900">{step.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-700">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}